import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LinkType } from '../interfaces/link-type.interface';

@Injectable({
	providedIn: 'root',
})
export class LinkTypeService {
	readonly url: string = 'LinkType';

	constructor(private http: HttpClient) {}

	public getAllLinkTemplates(): Observable<LinkType[]> {
		return this.http.get<LinkType[]>(this.url + '/' + 'GetAllLinkTypes');
	}
}
